import { buildCollection, buildProperty } from "@firecms/core";
import type { ContentScopeId } from "../workspace/collectionIds";
import type { Locale } from "../localization/constants";
import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";

export type LedgerEntryType =
    | "LEVEL_REWARD"
    | "SPEND"
    | "ADJUSTMENT";

export type LedgerEntry = {
    type: LedgerEntryType;
    coinsDelta: number;
    levelId?: string;
    levelCode?: string;
    createdAt: Date;
};

export const buildParticipantLedgerCollection = (
    contentScopeId: ContentScopeId,
    locale: Locale = getAdminUiLocale()
) => {
    const t = getAdminT(locale);
    void contentScopeId;
    return buildCollection<LedgerEntry>({
        name: t("participantEconomy.ledgerCollectionName"),
        singularName: t("participantEconomy.ledgerSingularName"),
        description: t("participantEconomy.ledgerDescription"),
        path: "ledgers",
        id: "ledgers",
        icon: "ReceiptLong",
        initialSort: ["createdAt", "desc"],
        selectionEnabled: false,
        defaultSize: "s",
        permissions: () => ({
            read: true,
            edit: false,
            create: false,
            delete: false,
        }),
        propertiesOrder: ["createdAt", "type", "coinsDelta", "levelCode", "levelId"],
        properties: {
            createdAt: buildProperty({
                name: t("participantEconomy.ledgerCreatedAt"),
                dataType: "date",
                mode: "date_time",
            }),
            type: buildProperty({
                name: t("participantEconomy.ledgerType"),
                dataType: "string",
                enumValues: {
                    LEVEL_REWARD: t("participantEconomy.ledgerTypeLevelReward"),
                    SPEND: t("participantEconomy.ledgerTypeSpend"),
                    ADJUSTMENT: t("participantEconomy.ledgerTypeAdjustment"),
                },
            }),
            coinsDelta: buildProperty({
                name: t("participantEconomy.ledgerCoinsDelta"),
                dataType: "number",
            }),
            levelCode: buildProperty({
                name: t("participantEconomy.ledgerLevel"),
                dataType: "string",
            }),
            levelId: buildProperty({
                name: "Level id",
                dataType: "string",
                hideFromCollection: true,
            }),
        },
    });
};
